<template>
    <div class=" bg-round bg-fff" :style="'margin-bottom: '+footbottom+'px;'">
        <div class="container">
            <header id="header">
                <div class="flex f-around">
                    <div class="header-li" @click="toPage('/competition/short')">短片奖（Short Film Award）</div>
                    <div class="header-li" @click="toPage('/competition/scenario')">剧本大赛（Script）</div>
                    <div class="header-li header-active" @click="toPage('/merge/competition-3')">翠麟表演奖（Actor Award）</div>
                    <div class="header-li" @click="toPage('/competition/winner')">获奖作品（Winners）</div>
                </div>
            </header>
        </div>
        <div class="container line-height-35 main-md">
            <div class="t-center">
                <img src="static/img/clLogo.png" alt="" srcset="" class="clLogo">
            </div>
            <br>
            FILMSTAR翠麟表演艺术奖的设立只为寻找和发现新一代华语电影演员。<br><br>

            FILMSTAR翠麟表演艺术奖依托SHISW上海（国际）短片周并在最佳演员奖的基础上发展而来；由SHISW上海（国际）短片周创始人张海先生设立并担任艺术指导，上海教育戏剧研究中心专家顾问、中国戏剧文学学会会员徐尧先生担任首席表演指导。<br><br>

            <span class="bold">为什么要参加翠麟表演艺术奖？</span><br>
            * 让更多优秀的华语青年电影人认识您，您将有机会与国际电影节获奖团队合作，共同征战国际电影节，获得国际专业奖项的认可。<br>
            * 您将有机会入选SHISW <span class="bold">华语电影演员扶持计划</span> ，获得美国TOCASTING亚裔演员选角平台的推荐，参与国际合拍项目。<br>
            * 入围者将获得SHISW官网的采访与宣传曝光。<br>
            * 入围者的简介资料将在SHISW官网华语演员人才库里展示。<br>
            * 入围者将获得选角推荐，有机会参与到SHISW短片周获奖导演的新片拍摄中。<br>
            * 入围者将邀请加入SHISW华语演员社群，获得最新咨询的同时拓展人脉，寻找合作伙伴。<br>
            * 入围者将获得NFR区块链数字认证证书。<br><br>

        <span class="bold"> 奖项设置：</span> <br><br>

            最佳演员<br>
            最具潜力演员<br>
            最佳童星演员<br>
            最佳动作演员<br>
            最佳配角演员<br>
            最佳特型演员<br>
            最佳上镜演员<br><br>

            最佳新人演员<br>
            最具潜力新人演员<br>
            最佳动作新人演员<br>
            最佳童星新人演员<br>
            最佳配角新人演员<br>
            最佳特型新人演员<br>
            最佳上镜新人演员<br><br>

            杰出表演艺术家<br>
            杰出表演教育家<br>
            优秀表演艺术家<br>
            优秀表演教育家<br><br>

            <span class="bold">荣誉证书</span> （NFR区块链数字认证证书）：获奖证书、荣誉提名证书、入围证书、荣誉桂冠<br><br>

            <span class="bold">
                官方报名通道：<a href="http://www.shisw.net">www.shisw.net</a>
            </span> <br><br>

            <span class="bold">评审流程：</span><br>
            每两个月评审一次，月度获奖者将进入年度评审。<br><br>

            1、月度初选：<br>
            <span class="bold">在线提交资料</span> <br>
            * 个人简介<br>
            * 联系方式（手机号、微信号、邮箱）<br>
            * 免冠素颜照片1-3张<br>
            * 带妆形象照3-5张<br>
            * 影视代表作品（TVC、短片、电影至少1-2部完成的影片；电视剧至少1-2集完整的剧集；个人代表作品不接受片段视频，只接受完成影片。 ）<br>
            * 个人介绍视频<br>
            * 个人才艺展示视频<br>
            * 相关表演演出作品片段若干（可选）<br><br>

            2、公布月度入围名单。<br><br>

            3、月度复选：<br>
            * 在线视频复选（问答+命题表演）<br><br>

            4、公布月度获奖与提名名单。<br><br>
            5、月度提名者，如在本月度未获奖，将进入下一月度的复选候选名单，参与此月度复审环节，月度复审候选名单有效期直到本年度最后一轮月度评审结束。<br><br>

            6、月度获奖者晋级年度提名名单，参加年度决赛评选。<br><br>

            7、公布年度获奖与提名名单。<br><br>

        </div>

        <div class="btn">
            <div class="btn-next" @click="toPage('/creation/detail?id=5146154635328972346')">申请北美表演训练班 </div>

            <div class="btn-next" @click="toPage('/creation/detail?id=5146154635328972346')">申请电影表演训练营 </div>
        </div>
        <div class="img-a-bg">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer" onclick="location.href='http://www.shisw.net/'">
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";

   .img-person {
        width: 220px;
    }

    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }
    @media (min-width: 768px) {
        .header-li {
            // margin-right: 40px;
        }

        .main-md {
            margin: 0 auto;
            width: 680px;
        }
    }

    @media (max-width: 768px) {}

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/cp33.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }
    .clLogo{
        width: 30%;
    }

    .btn-next {
        width: 300px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        border-radius: 10px;
        text-align: center;
        background-color: #FB004D;
        margin: 40px auto;
        cursor: pointer;
        display: block;
        text-decoration: none;
    }

    .btn {
        width: 100%;
    }

    .btn a:hover {
        color: #fff;
    }
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                detail:"",
                Content:"",
                footbottom:123,
            };
        },
        created() {
           console.log("开始开发")
           this.getDetail();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "competition-1",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    this.Content=res.data.Data.Content;
                });
            },
            toPage(url){
                this.$router.push(url);
            }
        },
    };
</script>
